import React, { useEffect, useState } from "react";
import { useCertificateDownload, useStyles, useTranslations } from "examsbook-react-sdk/custom-hooks";
import { ReactComponent as CertificateIcon } from "../../assets/images/DownloadImg.svg";
import lock from "../../assets/images/lock.png";
import Download from "../../assets/images/Download.png";
import { useDispatch, useSelector } from "react-redux";
import { courseCertificateListAction } from "examsbook-react-sdk/actions/certificateAddResponse";
import { Typography, Box } from "@material-ui/core";
import { ColorsConstant } from "../../../src/constants/colorConstant";
import { setUnlockCertificate } from "examsbook-react-sdk/actions/getSelfLearningAction";

export default function CertificateCard({ sectionData }) {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  const t = useTranslations();
  const userName = user?.user?.name ? user?.user?.name : user?.name;
  const classes = useStyles(styles)();
  const [certificateData, setCertificateData] = useState([]);
  const { handleDownloadCertificate } = useCertificateDownload({userName});
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (sectionData?.data?.courseId?._id) {
      dispatch(
        courseCertificateListAction(sectionData?.data?.courseId?._id)
      ).then((res) => {
        setIsLoading(true);
        if (res?.data?.length) {
          setCertificateData(res?.data[0]);
          dispatch(setUnlockCertificate(res?.data?.[0]?.isCompleted))
        }
      });
    }
  }, [sectionData?.data?.courseId?._id]);

  const isCertCompleted =
    certificateData && certificateData?.isCompleted === true;
  const icon = isCertCompleted ? Download : lock;
  const courseName = useSelector(state => state.filteredCourseList.courseName);
  return (
    <>
    <Box style={{minHeight: '20px'}}>
      {!isCertCompleted && isLoading ? <Typography className={classes.certifiedText}>
        *{t('Complete the course and pass the evaluation test with')}
        {sectionData?.data?.evaluationTest[0]?.testId?.passingPercent}% {''}
        {t('to unlock the certificate')}
        </Typography> 
      : isLoading && <Typography className={classes.certifiedTextPass}>
        ✅ {t('Well done! You’ve successfully unlocked your course certificate, and it’s ready to download.')}
      </Typography>
      }
      </Box>
      <div
        className={classes.certificateContainer}
        onClick={() => isCertCompleted && handleDownloadCertificate(certificateData?.courseId?.name, certificateData?.completedOn)}
      >
        <div className={classes.content}>
          <Box className={classes.certificateImgBox}>
            <CertificateIcon className={classes.image} alt="Certificate" />
          </Box>
          <h6 className={classes.title}>
            {isCertCompleted
              ? certificateData && certificateData?.courseId?.name
              : courseName || sectionData?.data?.courseId?.name }
          </h6>
        </div>
        <img
          src={icon}
          alt={isCertCompleted ? "Download Icon" : "Lock icon"}
          style={{ maxWidth: "15px", cursor: "pointer" }}
        />
      </div>
    </>
  );
}

const styles = {
  certifiedText: {
    color: "#F75151",
    fontSize: "12px",
    fontWeight: 500,
    fontStyle: "italic",
    margin: "12px 16px",
  },
  certifiedTextPass: {
    color: "#2e7d32",
    fontSize: "12px",
    fontWeight: 500,
    fontStyle: "italic",
    margin: "12px 16px",
  },
  certificateContainer: {
    border: "1px solid #e7e7e7ee",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "1rem",
    margin: "15px 16px",
    padding: "12px",
    position: "relative",
    cursor: "pointer",
    borderRadius: "4px",
    background: "#FFFFFF",
    minHeight: "78px !important",
  },
  content: {
    display: "flex",
    alignItems: "center",
  },
  title: {
    margin: "0 1rem",
    color: ColorsConstant.descriptionColor,
    fontWeight: "500",
    fontSize: "16px",
    "@media (max-width: 959px)": {
      fontSize: "12px",
    },
  },
  image: {
    maxWidth: "40px",
    maxHeight: "40px",
    borderRadius: "2px",
  },
  icon: {
    cursor: "pointer",
    color: "blue",
    fontSize: "1.2rem",
  },
  certificateImgBox: {
    width: 40,
    height: 40,
    background: "rgba(18, 78, 120, 0.1019607843)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
};
